/**
 * CrownAnimation — crown emoji with a golden sunburst + rotating rays.
 * 12 conic rays sweep outward, gold aura pulses, crown bobs proudly.
 */
export default function CrownAnimation({ size = 140 }) {
  const rays = new Array(12).fill(0).map((_, i) => ({
    angle: (i * 360) / 12,
  }));
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative" }}
    >
      <style>{`
        @keyframes crown-rays {
          0%   { transform: rotate(0deg) scale(0.4); opacity: 0; }
          25%  { transform: rotate(30deg) scale(1.4); opacity: 1; }
          80%  { transform: rotate(60deg) scale(1.2); opacity: 0.9; }
          100% { transform: rotate(90deg) scale(1); opacity: 0; }
        }
        @keyframes crown-bob {
          0%   { transform: translateY(20px) scale(0.5); opacity: 0; filter: drop-shadow(0 0 0 rgba(251,191,36,0)); }
          25%  { transform: translateY(-8px) scale(1.5); opacity: 1; filter: drop-shadow(0 0 40px rgba(251,191,36,0.95)); }
          55%  { transform: translateY(0px) scale(1.3); opacity: 1; filter: drop-shadow(0 0 32px rgba(251,191,36,0.9)); }
          80%  { transform: translateY(-4px) scale(1.25); opacity: 0.95; filter: drop-shadow(0 0 28px rgba(245,158,11,0.8)); }
          100% { transform: translateY(0) scale(1); opacity: 0; filter: drop-shadow(0 0 0 rgba(251,191,36,0)); }
        }
      `}</style>
      {/* Rotating rays */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          animation: "crown-rays 1.4s ease-out forwards",
          transformOrigin: "center",
        }}
      >
        {rays.map((r, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 4,
              height: size * 0.5,
              background:
                "linear-gradient(180deg, rgba(251,191,36,0.9), rgba(251,191,36,0) 90%)",
              transformOrigin: "top center",
              transform: `translate(-50%, 0) rotate(${r.angle}deg)`,
            }}
          />
        ))}
      </div>
      {/* Crown emoji */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.7,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "crown-bob 1.4s cubic-bezier(.22,1,.36,1) forwards",
        }}
      >
        👑
      </div>
    </div>
  );
}
